import { createSelector } from 'reselect';
import { UserState } from './types';

interface RootState {
  user: UserState;
}

const selectUserState = (state: RootState) => state.user;

export const selectUsers = createSelector([selectUserState], (userState) => userState.users);

export const selectSelectedUser = createSelector(
  [selectUserState],
  (userState) => userState.selectedUser
);

export const selectUserLoading = createSelector(
  [selectUserState],
  (userState) => userState.loading
);

export const selectUserError = createSelector([selectUserState], (userState) => userState.error);

export const selectUserSuccess = createSelector(
  [selectUserState],
  (userState) => userState.success
);

export const selectUserPagination = createSelector(
  [selectUserState],
  (userState) => userState.pagination
);

export const selectUsersCount = createSelector([selectUsers], (users) => users.length);

export const selectUserById = (id: string) =>
  createSelector([selectUsers], (users) => users.find((user) => (user._id) === id));

export const selectUsersByRole = (roleId: string) =>
  createSelector([selectUsers], (users) => users.filter((user) => user.roleId === roleId));

export const selectFilteredUsers = (searchTerm: string) =>
  createSelector([selectUsers], (users) => {
    if (!searchTerm) return users;

    const term = searchTerm.toLowerCase();
    return users.filter(
      (user) => user.name.toLowerCase().includes(term) || user.email.toLowerCase().includes(term)
    );
  });
